import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, FormBuilder, FormGroup, Validators, ValidatorFn } from '@angular/forms';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'app-edit-health-dialog',
    templateUrl: './edit-health-dialog.component.html',
    styleUrls: ['./edit-health-dialog.component.css'],
    standalone: false
})
export class HealthEditDialogComponent {
  healthForm: FormGroup;

  bloodGroups: any[] = [];
  ethnicities: any[]=[];
  country:any;
  height:any;
  weight:any;
  profileData:any;
  gender_list = ["Female","Male","Others"];
  maxDate = new Date();
  subitted = false;

  get f() {
    return this.healthForm.controls;
  }
  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<HealthEditDialogComponent>,
    public auth: AuthService, private router: Router,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

    this.healthForm = this.fb.group({
      // height: [data?.height || '', [Validators.required, Validators.min(1), Validators.max(299),  Validators.pattern(/^\d{1,3}(\.\d{1,2})?$/) ]],
      // weight: [data?.weight || '', [Validators.required, Validators.min(1), Validators.max(999),  Validators.pattern(/^\d{1,3}(\.\d{1,2})?$/) ]],
      height: [
        data?.height || '', 
        [
          Validators.required, 
          Validators.pattern(/^\d{1,3}(\.\d{1,2})?$/),
          heightValidator(() => this.healthForm?.value?.heightUnit || 'cm') // <-- dynamic
        ]
      ],
      weight: [
        data?.weight || '', 
        [
          Validators.required, 
          Validators.pattern(/^\d{1,3}(\.\d{1,2})?$/),
          weightValidator(() => this.healthForm?.value?.weigthtUnit || 'kg') // <-- dynamic
        ]
      ],
      bloodGroup: [data?.bloodGroup || '', Validators.required],
      ethnicity: [data?.ethnicity || '', Validators.required],
      heightUnit:[data?.heightUnit || 'cm'],
      weigthtUnit:[data?.weigthtUnit || 'kg'],
      gender:[data?.gender || '', Validators.required],
      dob:[data?.dob ? new Date(data.dob) : '', Validators.required],

    });
  }
   
  ngOnInit() {
    console.log('data',this.data)
    this.getEthnicity();
    this.getBloodGroup();
    this.getUnits();

    this.healthForm.get('heightUnit')?.valueChanges.subscribe((unit: string) => {
      this.height = unit;  // update variable bound to label
      const heightCtrl = this.healthForm.get('height');

      if (heightCtrl) {
        // Trigger validation with current value
        heightCtrl.setValue(heightCtrl.value);
        heightCtrl.updateValueAndValidity();
      }
    });

    this.healthForm.get('weigthtUnit')?.valueChanges.subscribe((unit: string) => {
      this.weight = unit;  // update variable bound to label
      const weightCtrl = this.healthForm.get('weight');
      if (weightCtrl) {
        // Trigger validation with current value
        weightCtrl.setValue(weightCtrl. value);
        weightCtrl.updateValueAndValidity();
      }
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onNumberInput(event: Event, ctrlName: string) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // regex to allow numbers with up to 2 decimals
    const regex = /^\d*\.?\d{0,2}$/;

    if (!regex.test(value)) {
      // remove the last character if it exceeds 2 decimals
      input.value = value.slice(0, -1);
      // update form control
      this.healthForm.get(ctrlName)?.setValue(input.value, { emitEvent: false });
    }
  }


  getError(ctrlName: any): any {
    const ctrl: AbstractControl | null = this.healthForm.get(ctrlName as string);
    if (!ctrl) return null;

    // show errors only after submit or user interaction
    const shouldShow = this.subitted || ctrl.touched || ctrl.dirty;
    if (!shouldShow || !ctrl.errors) return null;

    const e = ctrl.errors;
    if (e['required']) return 'This field is required';
    // if (e['pattern'])  return 'Only digits are allowed';
    // if (e['min'])      return `Minimum value is ${e['min'].min}`;
    // if (e['max'])      return `Maximum value is ${e['max'].max}`;
    // if (e['pattern']) {
    //   return `${ctrlName} must be a valid number (up to 2 decimal places)`;
    // }
    if (e['heightRange']) return e['heightRange'];
    if (e['weightRange']) return e['weightRange'];

    return 'Enter a valid value';
  }

  onSave(): void {
    this.subitted = true; // (fix typo from subitted)

    if (this.healthForm.invalid) {
      this.healthForm.markAllAsTouched();
      return;
    }

  if (!this.healthForm.valid) {
    this.toastr.error('Please fix the errors before saving.');
    return;
  }
    // console.log('Form Values:', this.healthForm.value);
    // console.log('Profile Data:', this.profileData);
    // console.log('Data ID:', this.data);
    
  // Format DOB only if present
  const rawDob = this.healthForm.value.dob;
  const dob = rawDob ? (this.datePipe.transform(rawDob, 'MM-dd-yyyy') || '') : '';
  const dob2 = rawDob ? (this.datePipe.transform(rawDob, 'dd-MM-yyyy') || '') : '';

  // Build payload once
  const payload = {
    gender: this.healthForm.value.gender,
    height: Number(this.healthForm.value.height),
    weight: Number(this.healthForm.value.weight),
    ethnicity: this.healthForm.value.ethnicity,
    bloodGroup: this.healthForm.value.bloodGroup,
    firstName: this.profileData?.first_name || '',
    lastName: this.profileData?.last_name || '',
    heightUnit: this.healthForm.value.heightUnit,   // unit label/string
    weigthtUnit: this.healthForm.value.weigthtUnit,   // fix typo: was 'weigthtUnit'
    dob,
    addon: []
  };

  // Trimmed version for digicoffer
  const digicofferPayload = {
    first_name: payload.firstName,
    last_name: payload.lastName,
    dob: dob2,
    gender: payload.gender.toLowerCase()
  };

  // Update if ID exists, else create
  const hasId = !!this.data?.id;

  const req$ = hasId
  ? forkJoin([
      this.auth.update_profile_list(this.data.id, payload),
      this.auth.updateProfile(digicofferPayload)
    ])
  : 
    forkJoin([
      this.auth.create_profile_list(payload),
      this.auth.updateProfile(digicofferPayload)
    ])

  req$.subscribe({
    next: (res: any) => {
      console.log('Response:', res);
      //if (res) {
        this.toastr.success(
          hasId ? 'Health information updated successfully!' : 'Health information created successfully!'
        );
        //this.dialogRef.close(this.healthForm.value);
        this.onCancel();
      //}
    },
    error: (err: any) => {
      console.error(err);
      this.toastr.error('Something went wrong. Please try again.');
    }
  });
   //this.refreshRoute();
   window.location.reload();
}

  // refreshRoute() {
  //   console.log('Refreshing route...');
  //   const currentUrl = this.router.url;
  //   this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
  //     this.router.navigate([currentUrl]);
  //   });
  // }

  getEthnicity(){
    this.auth.get_ethnicity().subscribe((res:any) =>{
      this.ethnicities = res.data.ethnicity;

    });

  }
  getBloodGroup(){
    this.auth.get_bloodgrps().subscribe((res:any) =>{
      this.bloodGroups = res.data.bloodgroup;
  
    });

  }
  getUnits(){

     this.auth.get_digicoffer_profile().subscribe((user: any) => {
      this.profileData = user.data?.profile;
    })

    // this.auth.get_citizenship().subscribe((res:any)=>{
    //   if(res.error==false){
    //     for (let i = 0; i < res.data.citizenships.length; i++) {

    //       if(res.data.citizenships[i].index == "citizen_primary"){
    //         this.country = res.data.citizenships[i].country  
    //         if(this.country== "usa" || this.country == "united states of america"||this.country=="USA"){
    //           this.height ="feet"
    //           this.weight="lbs"
    //           this.healthForm.patchValue({
    //             heightUnit: this.height,
    //             weigthtUnit: this.weight
    //           });

    //         } else {
    //           this.height ="cm"
    //           this.weight="kg"
    //           this.healthForm.patchValue({
    //             heightUnit: this.height,
    //             weigthtUnit: this.weight
    //           });

    //            }


    //       }
    //     }
       
        

  
     

        
        
    //   }

    // })
    this.height = this.data?.heightUnit || 'cm'
    this.weight = this.data?.weigthtUnit || 'kg'
     
  }
   
   
}



export function heightValidator(getUnit: () => string): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value === null || control.value === '') return null;

    const val = Number(control.value);
    const unit = getUnit();

    if (unit === 'cm' && (val < 30 || val > 272)) {
      return { heightRange: 'Height must be between 30 and 272 cm' };
    }

    if (unit === 'inch' && (val < 11.8 || val > 107)) {
      return { heightRange: 'Height must be between 11.8 and 107 inches' };
    }

    if (unit === 'feet' && (val < 1.0 || val > 8.0)) {
      return { heightRange: 'Height must be between 1 and 8 feet' };
    }

    return null; // valid
  };
}

export function weightValidator(getUnit: () => string): ValidatorFn {
  return (control: AbstractControl) => {
    if (control.value === null || control.value === '') return null;

    const val = Number(control.value);
    const unit = getUnit();

    if (unit === 'kg' && (val < 2 || val > 300)) {
      return { weightRange: 'Weight must be between 2 and 300 kg' };
    }

    if (unit === 'lbs' && (val < 4.4 || val > 660)) {
      return { weightRange: 'Weight must be between 4.4 and 660 lbs' };
    }

    return null;
  };
}

